//   For Assistance <Phone fontSize="inherit"/> { brand == "Thrifty" && checkin.country == "AU" ? <Link href="tel:13 61 39">13 61 39</Link> : brand == "Dollar" && checkin.country == "AU" ? <Link href="tel:1800 501 934">1800 501 934</Link> : checkin.country == "AU" ? <Link href="tel:13 30 39">13 30 39</Link>: <Link href="tel:0800 654 321">0800 654 321</Link>}
import getBrandFromUrl from "./getBrandFromUrl";
import getCountryFromURL from "./getCountryFromUrl";
function getAssistanceNumber() {
  const brand = getBrandFromUrl().toLowerCase();
  const country = getCountryFromURL().toLowerCase();
  if (brand === "thrifty" && country === "au") {
    return "13 61 39";
  } else if (brand === "dollar" && country === "au") {
    return "1800 501 934";
  } else if (country === "au") {
    return "13 30 39";
  } else {
    return "0800 654 321";
  }
}

export default getAssistanceNumber;
